import { makeStyles } from '@material-ui/core';

export const vendasStyles = makeStyles({
  situacaoContainer: {
    display: 'inline-flex',
    padding: '0px 10px 0px 10px',
  },
  badge: {
    color: '#ffffff',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 10,
    fontWeight: 600,
    borderRadius: '0px !important',

    textAlign: 'center',
  },
  badgeVendaAprovada: {
    backgroundColor: '#2dc44d',
  },
  badgeEmOrcamento: {
    backgroundColor: '#3286a8',
  },
  badgeOrcamentoRecusado: {
    backgroundColor: '#b53838',
  },
  buttonContainerAtrasado: {
    color: 'white',
    marginLeft: 10,
    padding: 2,
    backgroundColor: 'rgba(233, 170, 23, 0.8)',
    '&:hover': {
      backgroundColor: 'rgba(233, 170, 23, 1)',
      boxShadow: 'none',
      borderColor: 'rgba(233, 170, 23, 0)',
    },
  },
  buttonContainerEmailVisualizado: {
    color: 'rgba(59, 148, 142, 0.8)',
    marginLeft: 10,
    padding: 2,
    border: 0,
    '&:hover': {
      color: 'rgba(59, 148, 142, 1)',
    },
  },
});
